import { create } from "zustand";
import { persist } from "zustand/middleware";

export type CurrencyCode = "PKR" | "AED" | "USD";

interface CurrencyStore {
    currency: CurrencyCode;
    setCurrency: (code: CurrencyCode) => void;
}

const PERSIST_KEY = "maeiz-customer-currency";
const VALID_CURRENCIES: CurrencyCode[] = ["PKR", "AED", "USD"];

const getInitialCurrency = (): CurrencyCode => {
    if (typeof window !== "undefined") {
        const stored = localStorage.getItem(PERSIST_KEY);
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                const code = parsed?.state?.currency;
                if (code && VALID_CURRENCIES.includes(code)) return code;
            } catch {
                /* ignore */
            }
        }
    }
    return "PKR";
};

export const useCurrencyStore = create<CurrencyStore>()(
    persist(
        (set) => ({
            currency: getInitialCurrency(),
            setCurrency: (code) => set({ currency: code }),
        }),
        {
            name: PERSIST_KEY,
        }
    )
);
